import { Preferences, SetOptions } from '@capacitor/preferences'

export const setPreferences = async (obj: SetOptions) => {
  try {
    await Preferences.set(obj)
  } catch (error) {
    console.error(`preferences set ${JSON.stringify(obj)} failed`, error)
  }
}

export const getPreferences = async (key: string) => {
  try {
    const { value } = await Preferences.get({ key })
    return value
  } catch (error) {
    console.error(`preferences get ${key} failed`, error)
  }
}

export const removePreferences = async (key: string) => {
  try {
    await Preferences.remove({ key })
  } catch (error) {
    console.error(`preferences remove ${key} failed`, error)
  }
}
